module.exports = __webpack_public_path__ + "static/img/6622_phase_function_Paper_PointsHejduk_Prediction.0bdb7c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6622_phase_function_Paper_PointsHejduk_Prediction.png
// module id = oKyL
// module chunks = 0